import { isString } from '../../util';
import { getCurrentScope, onScopeDispose, watch, unref } from 'vue';
const noop = () => { };
function tryOnScopeDispose(fn) {
    if (getCurrentScope()) {
        onScopeDispose(fn);
        return true;
    }
    return false;
}
function unrefElement(elRef) {
    let _a;
    const plain = unref(elRef);
    return (_a = plain == null ? void 0 : plain.$el) != null ? _a : plain;
}
export function useEventListener(...args) {
    let target;
    let event;
    let listener;
    let options;
    if (isString(args[0])) {
        [event, listener, options] = args;
        target = window;
    }
    else {
        [target, event, listener, options] = args;
    }
    if (!target)
        return noop;
    let cleanup = noop;
    const stopWatch = watch(() => unrefElement(target), el => {
        cleanup();
        if (!el)
            return;
        el.addEventListener(event, listener, options);
        cleanup = () => {
            el.removeEventListener(event, listener, options);
            cleanup = noop;
        };
    }, { immediate: true, flush: 'post' });
    const stop = () => {
        stopWatch();
        cleanup();
    };
    tryOnScopeDispose(stop);
    return stop;
}
